import {
  Card,
  CardContent,
  CardHeader,
} from '@/components/ui/card'
import { Skeleton } from '@/components/ui/skeleton'

export function DashboardOverviewSkeleton() {
  return (
    <div className='grid grid-cols-1 gap-4 lg:grid-cols-7'>
      <div className='col-span-1 lg:col-span-4'>
        <Card>
          <CardHeader>
            <Skeleton className='h-6 w-48 mb-2' />
            <Skeleton className='h-4 w-full max-w-md' />
          </CardHeader>
          <CardContent className='pl-2'>
            <Skeleton className='h-[350px] w-full' />
          </CardContent>
        </Card>
      </div>

      <div className='col-span-1 lg:col-span-3'>
        <Card>
          <CardHeader>
            <Skeleton className='h-6 w-48 mb-2' />
            <Skeleton className='h-4 w-full max-w-xs' />
          </CardHeader>
          <CardContent>
            <div className='space-y-8'>
              {Array.from({ length: 5 }).map((_, index) => (
                <div key={index} className='flex items-center gap-4'>
                  <Skeleton className='h-9 w-9 rounded-full' />
                  <div className='flex flex-1 flex-wrap items-center justify-between'>
                    <div className='space-y-1'>
                      <Skeleton className='h-4 w-32' />
                      <Skeleton className='h-3 w-24' />
                    </div>
                    <Skeleton className='h-5 w-16' />
                  </div>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  )
}
